import { itineraryApi, useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { INTL_CANCELATION_INSURANCE } from '@/src/constants/itnerary'
import { useAppDispatch } from '@/src/redux/store'
import { Fare } from '@/src/types/itinerary'
import { useCallback, useState } from 'react'
import useGetItineraryId from '../useGetItineraryId'

const useFareCards = () => {
    const dispatch = useAppDispatch()
    const itineraryId = useGetItineraryId()

    const [benefitsDrawerOpen, setBenefitsDrawerOpen] = useState(false)
    const [benefitsUrl, setBenefitsUrl] = useState<string>('')

    const { faresList, fareFamilyEnabledOnReview } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => ({
                faresList: data?.faresList || [],
                fareFamilyEnabledOnReview: data?.meta?.fareFamilyEnabledOnReview
            })
        }
    )
    let faresToDisplay: Fare[] = []
    if (fareFamilyEnabledOnReview) {
        faresToDisplay = faresList?.[0]?.filter(
            (fare: Fare) => fare.fareMetaMessages?.[0].category !== 'Standard fare'
        )
    } else {
        faresToDisplay = faresList?.[0] || []
    }

    const onFareSelect = (selectedFare: Fare) => {
        dispatch(
            itineraryApi.util.updateQueryData('getItineraryData', { itineraryId }, draft => {
                if (draft?.faresList?.[0]) {
                    const fareToSelect = draft.faresList[0].find(
                        (fare: Fare) =>
                            fare.fareMetaMessages?.[0].category === selectedFare.fareMetaMessages?.[0].category
                    )

                    if (fareFamilyEnabledOnReview && fareToSelect?.selected) {
                        fareToSelect.selected = false
                    } else {
                        // Unselect all fares first
                        draft.faresList[0].forEach((fare: any) => {
                            fare.selected = false
                        })
                        // Select the clicked fare
                        if (fareToSelect) {
                            fareToSelect.selected = true
                        }
                    }
                }
            })
        )
    }

    const formatFareTitle = (title: string) => {
        if (title === 'NORMAL FARE') {
            return 'Standard fare'
        }
        return title
    }

    const onViewBenefits = useCallback((category: string) => {
        const base = typeof window !== 'undefined' ? window.location.origin : ''
        let url = ''
        if (category === INTL_CANCELATION_INSURANCE) {
            url = `${base}/ezcancel/free-flight-cancellation`
        } else {
            url = `${base}/flexifly`
        }
        setBenefitsUrl(url)
        setBenefitsDrawerOpen(true)
    }, [])

    const closeBenefitsDrawer = useCallback(() => {
        setBenefitsDrawerOpen(false)
    }, [])

    return {
        faresList,
        faresToDisplay,
        fareFamilyEnabledOnReview,
        onFareSelect,
        formatFareTitle,
        onViewBenefits,
        benefitsDrawerOpen,
        benefitsUrl,
        closeBenefitsDrawer
    }
}

export default useFareCards